interface TwoFactorModeToggleProps {
  isSignup: boolean
  isAuthenticatorEnabled: boolean
  isAuthenticatorMode: boolean
  resendPending: boolean
  onSwitchToAuthenticator: () => void
  onSwitchToPhone: () => void
}

const TwoFactorModeToggle = ({
  isSignup,
  isAuthenticatorEnabled,
  isAuthenticatorMode,
  resendPending,
  onSwitchToAuthenticator,
  onSwitchToPhone,
}: TwoFactorModeToggleProps) => (
  <>
    {/* Show "Verify with Authenticator app" button only for login flow */}
    {isSignup === false && isAuthenticatorEnabled && !isAuthenticatorMode && (
      <button
        type="button"
        className={`${AUTH_LINK_CLASS} w-full text-left text-s-500`}
        onClick={onSwitchToAuthenticator}
        data-testid="button-verify-authenticator"
      >
        Verify with Authenticator app
      </button>
    )}

    {/* Show "Verify with Phone Number" button when in authenticator mode */}
    {isAuthenticatorMode && isAuthenticatorEnabled && (
      <button
        type="button"
        className={`${AUTH_LINK_CLASS} w-full text-left text-s-500`}
        onClick={onSwitchToPhone}
        disabled={resendPending}
        data-testid="button-verify-phone"
      >
        {resendPending ? 'Sending...' : 'Verify with Phone Number'}
      </button>
    )}
  </>
)

export default TwoFactorModeToggle

import { AUTH_LINK_CLASS } from './auth-styles'
